import {Route, useLocation} from "react-router-dom";
import React from "react";
import {Routes} from "react-router";
import {ClientList} from "./ClientList";
import {ClientView} from "./ClientView/ClientView";
import {ClientInquiriesList} from "./ClientInquiries";
import {useProviderProfile} from "../../../../ProviderProfileProvider";

export const useClientsTab = () => {

  const location = useLocation();
  const {business} = useProviderProfile();

  const clientsTab = {
    label: 'Clients',
    link: '/home/clients',
    isSelected: location.pathname == '/home/clients',
  };

  const inquiriesTabs = {
    label: 'Client Inquiries',
    link: '/home/clients/inquiries',
    isSelected: location.pathname.startsWith('/home/clients/inquiries'),
  };
  
  
  if (business?.businessSettings?.newClientsMustInquire) {
    return [clientsTab, inquiriesTabs]
  } else {
    return [clientsTab];
  }
}

export const ClientsRouter = () => {

  
  return <Routes>
    <Route path={'/:idParam/*'} element={<ClientView/>}/>
    <Route path={'/'} element={<ClientList/>}/>
    <Route path={'/inquiries'} element={<ClientInquiriesList/>}/>
  </Routes>
}
